<script setup lang="ts">
import { watch } from 'vue';

import AppFrame from './components/AppFrame.vue';
import FeedbackHost from './components/FeedbackHost.vue';
import FullPageLoading from './components/FullPageLoading.vue';
import { useFeedback } from './composables/useFeedback';
import { useMe } from './composables/useMe';
import { useVuetifyThemeSync } from './composables/useVuetifyThemeSync';
import { sessionExpired } from './services/authState';

useVuetifyThemeSync();

// AppFrame renders immediately; mounting it before /me resolves would flash empty chrome, so gate
// the routed content behind the loading state instead.
const { isPending } = useMe();

// A terminal 401 (refresh exhausted) flips this once. Sticky notice (no life) so the prompt to
// re-authenticate stays put; views also render an inline banner.
const { notify } = useFeedback();
watch(sessionExpired, (expired) => {
  if (!expired) return;
  notify({ tone: 'warn', summary: 'Session expired', detail: 'Sign in again to continue.' });
});
</script>

<template>
  <v-app>
    <FullPageLoading v-if="isPending" />
    <AppFrame v-else>
      <router-view />
    </AppFrame>
    <FeedbackHost />
  </v-app>
</template>
